import { IMapField } from 'interfaces/superAdmin.interface';
import * as MetaMappingsTypes from './metaMappings.types';
import { IInitialMetaState, IShopifyConnectorMapsItem } from 'interfaces/meta.interface';
import { IaddFieldToMapAPIResponseDataItem } from 'api/endpoints/meta/meta.response.interface';

export type TMetaMappingsDispatchReducer =
  | {
      type: typeof MetaMappingsTypes.SET_MAP_SELECTED;
      payload: string | null;
    }
  | {
      type: typeof MetaMappingsTypes.SET_IS_LOADING_MAPS;
      payload: boolean;
    }
  | {
      type: typeof MetaMappingsTypes.SET_IS_LOADING_CREATE_MAP;
      payload: boolean;
    }
  | {
      type: typeof MetaMappingsTypes.SET_IS_LOADING_UPDATE_MAP;
      payload: boolean;
    }
  | {
      type: typeof MetaMappingsTypes.SET_IS_LOADING_ADD_MAP_TO_CONNECTION;
      payload: boolean;
    }
  | {
      type: typeof MetaMappingsTypes.SET_IS_LOADING_DELETE_MAP_FROM_CONNECTION;
      payload: boolean;
    }
  | {
      type: typeof MetaMappingsTypes.DELETE_MAP;
      payload: string;
    }
  | {
      type: typeof MetaMappingsTypes.SET_IS_LOADING_DELETE_MAP;
      payload: {
        loading: boolean;
        mapId: string | null;
      };
    }
  | {
      type: typeof MetaMappingsTypes.ADD_FIELDS_TO_MAP;
      payload: {
        mapId: string;
        mapFields: Array<
          IaddFieldToMapAPIResponseDataItem & { map_field: IMapField | undefined }
        >;
      };
    }
  | {
      type: typeof MetaMappingsTypes.GET_MAPS;
      payload: Array<IShopifyConnectorMapsItem>;
    }
  | {
      type: typeof MetaMappingsTypes.CREATE_MAP;
      payload: IShopifyConnectorMapsItem;
    }
  | {
      type: typeof MetaMappingsTypes.UPDATE_MAP;
      payload: {
        id: string;
        data: {
          tag: string;
          description: string;
          period: number;
        };
      };
    };

export function handleMappings(
  state: IInitialMetaState,
  action: TMetaMappingsDispatchReducer
) {
  const { type, payload } = action;

  switch (type) {
    case MetaMappingsTypes.GET_MAPS: {
      const getMaps: IInitialMetaState = {
        ...state,
        mappings: payload,
      };
      return getMaps;
    }

    case MetaMappingsTypes.SET_IS_LOADING_MAPS: {
      const setIsLoadingMaps: IInitialMetaState = {
        ...state,
        isLoadingMaps: payload,
      };
      return setIsLoadingMaps;
    }

    case MetaMappingsTypes.DELETE_MAP: {
      const deleteMap: IInitialMetaState = {
        ...state,
        mappings: state.mappings.filter((item) => item.map.id !== payload),
      };
      return deleteMap;
    }

    case MetaMappingsTypes.SET_IS_LOADING_DELETE_MAP: {
      const setIsLoadingDeleteMap: IInitialMetaState = {
        ...state,
        isLoadingDeleteMap: {
          loading: payload.loading,
          mapId: payload.mapId,
        },
      };
      return setIsLoadingDeleteMap;
    }

    case MetaMappingsTypes.SET_MAP_SELECTED: {
      const setMapSelected: IInitialMetaState = {
        ...state,
        mapSelected: !payload
          ? null
          : (state.mappings.find(
              (item) => item.map.id === payload
            ) as IShopifyConnectorMapsItem),
      };
      return setMapSelected;
    }

    case MetaMappingsTypes.CREATE_MAP: {
      const createMap: IInitialMetaState = {
        ...state,
        mappings: [payload, ...state.mappings],
      };
      return createMap;
    }

    case MetaMappingsTypes.SET_IS_LOADING_CREATE_MAP: {
      const setIsLoadingCreateMap: IInitialMetaState = {
        ...state,
        isLoadingCreateMap: payload,
      };
      return setIsLoadingCreateMap;
    }

    case MetaMappingsTypes.UPDATE_MAP: {
      const updateMap: IInitialMetaState = {
        ...state,
        mappings: state.mappings.map((item) =>
          item.map.id === payload.id ? { ...item, ...payload.data } : item
        ),
      };
      return updateMap;
    }

    case MetaMappingsTypes.SET_IS_LOADING_UPDATE_MAP: {
      const setIsLoadingUpdateMap: IInitialMetaState = {
        ...state,
        isLoadingUpdateMap: payload,
      };
      return setIsLoadingUpdateMap;
    }

    case MetaMappingsTypes.SET_IS_LOADING_ADD_MAP_TO_CONNECTION: {
      const setIsLoadingAddMapToConnection: IInitialMetaState = {
        ...state,
        isLoadingAddMapToConnection: payload,
      };
      return setIsLoadingAddMapToConnection;
    }

    case MetaMappingsTypes.SET_IS_LOADING_DELETE_MAP_FROM_CONNECTION: {
      const setIsLoadingDeleteMapFromConnection: IInitialMetaState = {
        ...state,
        isLoadingDeleteMapFromConnection: payload,
      };
      return setIsLoadingDeleteMapFromConnection;
    }

    case MetaMappingsTypes.ADD_FIELDS_TO_MAP: {
      const addFieldsToMap: IInitialMetaState = {
        ...state,
        mappings: state.mappings.map((item) => {
          if (item.map.id === payload.mapId) {
            return {
              ...item,
              map: {
                ...item.map,
                map_field_maps: payload.mapFields,
              },
            };
          }
          return item;
        }) as Array<IShopifyConnectorMapsItem>,
      };
      return addFieldsToMap;
    }

    default:
      return state;
  }
}
